
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { TaskResultMsgModule_updateState, TaskResultMsgModule_fail, TaskResultMsgModule_success, TaskResultMsgModule_finish, InputMsg_$reflection } from "../Types.jsx";
import { decimal_type, record_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { Bruch_ErstelleZufälligenDezimalBruch_Z6EA5070B, Bruch_Create_Z37302880, Bruch_$reflection } from "../Bruch.jsx";
import { DecimalInput__WithInput_Z524259A4, DecimalInput__Clear_Z1FBCCD16, DecimalInput__WithKomma, DecimalInput_Error_6B54009B, DecimalInput__get_Value, DecimalInput_get_Empty, DecimalInput__get_HasValue, Editable$2, DecimalInput_$reflection } from "../Input.jsx";
import { Ausdruck } from "../Ausdruck.jsx";
import { interpolate, toText } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/String.js";
import { equals, op_Division } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";
import Decimal from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InputMsg", "Ok"];
    }
}

export function Msg_$reflection() {
    return union_type("MatheApp.Domain.BruchZuDezimal.Msg", [], Msg, () => [[["Item", InputMsg_$reflection()]], []]);
}

export class EingabeState extends Record {
    constructor(Bruch, Dezimal) {
        super();
        this.Bruch = Bruch;
        this.Dezimal = Dezimal;
    }
}

export function EingabeState_$reflection() {
    return record_type("MatheApp.Domain.BruchZuDezimal.EingabeState", [], EingabeState, () => [["Bruch", Bruch_$reflection()], ["Dezimal", DecimalInput_$reflection()]]);
}

export class ErfolgState extends Record {
    constructor(Bruch, DezimalWert) {
        super();
        this.Bruch = Bruch;
        this.DezimalWert = DezimalWert;
    }
}

export function ErfolgState_$reflection() {
    return record_type("MatheApp.Domain.BruchZuDezimal.ErfolgState", [], ErfolgState, () => [["Bruch", Bruch_$reflection()], ["DezimalWert", decimal_type]]);
}

export class State extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EingabeState", "ErfolgState"];
    }
}

export function State_$reflection() {
    return union_type("MatheApp.Domain.BruchZuDezimal.State", [], State, () => [[["Item", EingabeState_$reflection()]], [["Item", ErfolgState_$reflection()]]]);
}

export function State__get_Bruch(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Bruch;
    }
    else {
        return this$.fields[0].Bruch;
    }
}

export function State__get_Dezimal(this$) {
    if (this$.tag === 1) {
        return new Editable$2(1, [this$.fields[0].DezimalWert]);
    }
    else {
        return new Editable$2(2, [this$.fields[0].Dezimal]);
    }
}

export function State__get_Format(this$) {
    return new Ausdruck(6, [State__get_Bruch(this$).Ausdruck, State__get_Dezimal(this$).Ausdruck]);
}

export function State__get_CanOk(this$) {
    if (this$.tag === 1) {
        return false;
    }
    else {
        return DecimalInput__get_HasValue(this$.fields[0].Dezimal);
    }
}

export function State__get_CanClear(this$) {
    if (this$.tag === 1) {
        return false;
    }
    else {
        return DecimalInput__get_HasValue(this$.fields[0].Dezimal);
    }
}

export const initialState = new State(0, [new EingabeState(Bruch_Create_Z37302880(1, 10), DecimalInput_get_Empty())]);

export function create(random) {
    return new State(0, [new EingabeState(Bruch_ErstelleZufälligenDezimalBruch_Z6EA5070B(random), DecimalInput_get_Empty())]);
}

function input(transform, state) {
    if (state.tag === 0) {
        const es = state.fields[0];
        return new State(0, [new EingabeState(es.Bruch, transform(es.Dezimal))]);
    }
    else {
        return state;
    }
}

export function reduce(logger, state, action) {
    logger(toText(interpolate("Reducing decimal state: %A%P() with action: %A%P()", [state, action])));
    if (action.tag === 1) {
        if (state.tag === 1) {
            return TaskResultMsgModule_finish(state);
        }
        else if (DecimalInput__get_HasValue(state.fields[0].Dezimal)) {
            const d = DecimalInput__get_Value(state.fields[0].Dezimal);
            const erwarteterD = op_Division(new Decimal(state.fields[0].Bruch.Zähler), new Decimal(state.fields[0].Bruch.Nenner));
            if (equals(d, erwarteterD)) {
                return TaskResultMsgModule_success(new State(1, [new ErfolgState(state.fields[0].Bruch, d)]));
            }
            else {
                return TaskResultMsgModule_fail(input((_arg_3) => DecimalInput_Error_6B54009B(erwarteterD, d, "Falsch"), state));
            }
        }
        else {
            return TaskResultMsgModule_updateState(state);
        }
    }
    else {
        switch (action.fields[0].tag) {
            case 1:
                return TaskResultMsgModule_updateState(input(DecimalInput__WithKomma, state));
            case 2:
                return TaskResultMsgModule_updateState(input((_arg_2) => DecimalInput__Clear_Z1FBCCD16(_arg_2, action.fields[0].fields[0]), state));
            default:
                return TaskResultMsgModule_updateState(input((_arg) => DecimalInput__WithInput_Z524259A4(_arg, action.fields[0].fields[0]), state));
        }
    }
}

